import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Tooltip
} from '@patternfly/react-core';
import {
  AngleDownIcon,
  AngleLeftIcon
} from '@patternfly/react-icons';
import styles from './Breadcrumb.module.css';

const Breadcrumb = ({ breadcrumbPath, isExpanded, onExpand }) => {
  const breadcrumb = useMemo(() => breadcrumbPath.join(' / '), [breadcrumbPath]);
  const breadcrumbIcon = isExpanded ? <AngleDownIcon /> : <AngleLeftIcon />;

  const onBreadcrumb = useCallback(() => {
    onExpand(state => !state);
  }, [onExpand]);

  return (
    <>
      <Tooltip
        content={breadcrumb}
        flipBehavior={['bottom', 'right', 'top']}
      >
        <Button
          className={styles.ellipsizeLeft}
          variant="link"
          onClick={onBreadcrumb}
          icon={breadcrumbIcon}
          iconPosition="left"
        >{ breadcrumb }</Button>
      </Tooltip>
    </>
  );
};

Breadcrumb.propTypes = {
  breadcrumbPath: PropTypes.array.isRequired,
  onExpand: PropTypes.func.isRequired,
  isExpanded: PropTypes.bool.isRequired
};

export default Breadcrumb;
